import React from "react";
import { FiArrowLeft } from "react-icons/fi";

interface BackButtonProps {
  onBack: () => void;
  "aria-label"?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  onBack,
  "aria-label": ariaLabel = "Voltar para lista de conversas",
}) => (
  <button
    onClick={onBack}
    className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-200 active:scale-95 md:hidden"
    aria-label={ariaLabel}
  >
    <FiArrowLeft size={20} className="text-gray-600 dark:text-gray-300" />
  </button>
);
